class DuskInlineSearch extends HTMLElement {
  #onDocumentKeydown = (event) => {
    if (event.key !== 'Escape' || !this.classList.contains('is-expanded')) return;
    event.preventDefault();
    this.#collapse();
  };

  #onScrollOrResize = () => {
    this.#syncMobileFixedLayout();
  };

  connectedCallback() {
    this.#openBtn?.addEventListener('click', this.#onOpenClick);
    this.#closeBtn?.addEventListener('click', this.#onCloseClick);
    document.addEventListener('keydown', this.#onDocumentKeydown);
  }

  disconnectedCallback() {
    this.#unbindViewportListeners();
    this.#clearMobileFixedLayout();
    this.#openBtn?.removeEventListener('click', this.#onOpenClick);
    this.#closeBtn?.removeEventListener('click', this.#onCloseClick);
    document.removeEventListener('keydown', this.#onDocumentKeydown);
    this.#header?.classList.remove('header-search-expanded');
  }

  #onOpenClick = (event) => {
    event.preventDefault();
    this.#expand();
  };

  #onCloseClick = (event) => {
    event.preventDefault();
    this.#collapse();
  };

  get #openBtn() {
    return this.querySelector('[data-dusk-search-open]');
  }

  get #closeBtn() {
    return this.querySelector('[data-dusk-search-close]');
  }

  get #input() {
    return this.querySelector('input[name="q"]');
  }

  get #header() {
    return this.closest('header-component');
  }

  #isMobileSearchLayout() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  /** Header row can sit inside a page-width grid; fixed + rect keeps the bar edge-to-edge like retail. */
  #syncMobileFixedLayout() {
    if (!this.classList.contains('is-expanded') || !this.#isMobileSearchLayout()) return;
    const row = this.closest('.header__row');
    if (!row) return;
    const r = row.getBoundingClientRect();
    this.style.top = `${r.top}px`;
    this.style.height = `${r.height}px`;
  }

  #clearMobileFixedLayout() {
    this.style.top = '';
    this.style.height = '';
  }

  #bindViewportListeners() {
    window.addEventListener('scroll', this.#onScrollOrResize, true);
    window.addEventListener('resize', this.#onScrollOrResize);
    window.visualViewport?.addEventListener('resize', this.#onScrollOrResize);
    window.visualViewport?.addEventListener('scroll', this.#onScrollOrResize);
  }

  #unbindViewportListeners() {
    window.removeEventListener('scroll', this.#onScrollOrResize, true);
    window.removeEventListener('resize', this.#onScrollOrResize);
    window.visualViewport?.removeEventListener('resize', this.#onScrollOrResize);
    window.visualViewport?.removeEventListener('scroll', this.#onScrollOrResize);
  }

  #expand() {
    this.classList.add('is-expanded');
    this.#openBtn?.setAttribute('aria-expanded', 'true');
    this.#header?.classList.add('header-search-expanded');
    if (this.#isMobileSearchLayout()) {
      this.#bindViewportListeners();
      this.#syncMobileFixedLayout();
    }
    requestAnimationFrame(() => {
      this.#syncMobileFixedLayout();
      this.#input?.focus();
    });
  }

  #collapse() {
    this.#unbindViewportListeners();
    this.#clearMobileFixedLayout();
    this.classList.remove('is-expanded');
    this.#openBtn?.setAttribute('aria-expanded', 'false');
    this.#header?.classList.remove('header-search-expanded');
    this.#openBtn?.focus();
  }
}

if (!customElements.get('dusk-inline-search')) {
  customElements.define('dusk-inline-search', DuskInlineSearch);
}
